module.exports = __webpack_public_path__ + "static/media/profileBackground.02cd3469.png";